export const styles = {
  subHeaderBlock: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
  },
};
